module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS5.0e3a8498.jpg";